<template>
  <DBox
    :id="'cmp-accounting-invoices-invoice_sidewindow-invoice_payments'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_payment')}`"
    @add_click="onAddPayment"
  >
    <NTable
      class="invcoie-line-list dbox1"
      :headers="headers"
      :items="selectedInvoice.payments"
      :config="tableConfig"
      :id="'accounting-invoices-invoice_sidewindow-payments'"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('payment_date')">
            <span>{{ item.date }}</span>
          </td>
          <td v-bind="tdcon('money_account')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="selectedInvoice.disabled"
              :options="selectedInvoice.money_accountsTV"
              :placeholder="`${$t('select')} ${$t('money_account')}`"
              :selected="
                selectedInvoice.money_accountsTV.find(
                  (v) => v.value == item.money_account_id
                )
              "
              v-on:selectedChange="
                (e) => onMoneyAccountChange('money_account_id', e, item)
              "
              :bb="'0px'"
            ></Dropdown2>
          </td>
          <td v-bind="tdcon('amount')">
            <TextField2
              id="amount"
              class="dbox1"
              :showLabel="false"
              :disabled="selectedInvoice.disabled"
              :value="item['amount']"
              :bb="'0px'"
              :ta="'right'"
              @change="(e) => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('currency')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="selectedInvoice.disabled"
              :options="selectedInvoice.currenciesTV"
              :selected="
                selectedInvoice.currenciesTV.find(
                  (v) => v.value == item.currency_id
                )
              "
              v-on:selectedChange="
                (e) => onPaymentCurrencyChange('currency_id', e, item)
              "
              :bb="'0px'"
            ></Dropdown2>
          </td>
          <td v-bind="tdcon('exchange_rate')">
            <TextField2
              id="exchangerate"
              class="dbox1"
              :showLabel="false"
              :disabled="selectedInvoice.disabled"
              :value="item['exchangerate']"
              :bb="'0px'"
              :ta="'right'"
              @change="(e) => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('total')">
            <span style="text-align: right"
              >{{ getAmountInDefaultCurr(item) }}
              {{ $store.getters.account.client.default_currency }}
              <!-- {{ selectedInvoice.currency.currency_iso }} -->
            </span>
          </td>
          <td v-bind="tdcon('notes')">
            <TextField2
              id="notes"
              class="dbox1"
              :showLabel="false"
              :disabled="selectedInvoice.disabled"
              :value="item['notes']"
              :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('options')">
            <div style="padding-left: 2px" class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="(e) => onDeletePayment(item)"
                :alt="$t('delete_payment')"
                :title="$t('delete_payment')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { mapGetters } from "vuex";
import { parseNumber } from "../../../../utility";
import { tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { createTableHeader } from "../../../../plugins/datatable";
export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        fullHeight: true,
        headerStyle: 3,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("payment_date", {minw:120, f: 0.65 }),
        createTableHeader("money_account"),
        createTableHeader("amount", { ta: "right" }),
        createTableHeader("currency"),
        createTableHeader("exchange_rate",{minw:120, mw:120}),
        createTableHeader("total", { ta: "right", fw: 700 }),
        createTableHeader("notes", { f: 0.55 }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  methods: {
    onTextInputBlur: function (event, name, item) {
      this.$emit("changed", {
        name,
        value: event.target.value,
        item,
      });
    },
    onTextFieldChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        item,
      });
    },
    onVatTypechange: function (item, value) {
      this.$emit("changed", {
        name: "vat_type",
        value: value.value,
        item,
      });
    },
    onMoneyAccountChange: function (name, value, item) {
      this.$emit("changed", { name, value: value.value, item });
    },
    getAmountInDefaultCurr: function (item) {
      return this.$dft.curr(
        ((item.debit_credit ? item.debit_credit : 1) * item.amount) /
          (item.exchangerate ? item.exchangerate : 1)
      );
    },
    onPaymentCurrencyChange: function (name, value, item) {
      this.$emit("currency_changed", { name, value: value.value, item });
    },
    onDeletePayment: async function (item) {
      const confirmationResult = await confirmDelete(
        "Payment",
        `Date: ${item.date} Amount: ${item.amount}`
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", item);
      }
    },
    onAddPayment: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "set_status",
          invoice_id: this.selectedInvoice?.invoice?.invoice_id,
        },
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-accounting-invoices-invoice_sidewindow-invoice_payments {
}
</style>
